export default __webpack_public_path__ + "static/branding_preview-4a679fe66d75cd4e019e93863a003f94.webp";